import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app-module';
import * as Sentry from '@sentry/angular';
import { sentryConfig } from './sentry.config';

Sentry.init({
  ...sentryConfig,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
});

platformBrowser()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch((err) => console.error(err));
